// extracted by mini-css-extract-plugin
module.exports = {"scrim":"Scrim_scrim__3nlAO","show":"Scrim_show__1IESU"};